/* Neimien 2 — carrello Shopify (Ajax API), cassetto, buy box, quiz, eventi Meta. */
(function () {
  const C = window.N2 || {};
  const fmt = (cents) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const $ = (s, r = document) => r.querySelector(s); const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const bundleFor = (q) => Math.floor(q / 2) * C.bundle2 + (q % 2) * C.price;
  let cart = null;

  /* ---------- Test A/B del pre-checkout (27/09/2026) ---------- */
  // Ramo A = cassetto → checkout Shopify, com'era. Ramo B = cassetto → «Come vuoi pagare?» → (contanti) «Dove lo
  // spediamo?» → checkout Shopify già compilato col link al carrello (i dati non restano nell'indirizzo del checkout).
  // Il ramo si decide a sorte al primo articolo, sta nel carrello (_ab_precheckout) e passa all'ordine: così si
  // contano gli ordini per ramo. Spegnere il test: AB.attivo = false (tutte nel ramo A).
  // Prove: ?interno=1 (esclude dai conti) e ?ab=A o ?ab=B per forzare il ramo in questa scheda.
  const AB = { attivo: true, chiave: '_ab_precheckout' };
  const URL_DASH = 'https://visiione.com/neimien/dashboard';
  (function () {
    const q = new URLSearchParams(location.search);
    try { if (q.get('interno') === '1') sessionStorage.setItem('nei_interno', '1'); if (/^[AB]$/.test(q.get('ab') || '')) sessionStorage.setItem('nei_ab', q.get('ab')); } catch (e) {}
  })();
  const interno = () => { try { return sessionStorage.getItem('nei_interno') === '1'; } catch (e) { return false; } };
  const tr = (e, dati) => { try { document.dispatchEvent(new CustomEvent('n2:traccia', { detail: { e, dati: dati || null } })); } catch (x) {} };
  const forzato = () => { try { return sessionStorage.getItem('nei_ab'); } catch (e) { return null; } };
  const ramo = () => { const r = cart && cart.attributes && cart.attributes[AB.chiave]; return r && (AB.attivo || forzato()) ? r : 'A'; };
  let assegnando = null;
  function assegnaRamo() {
    // prova interna su un carrello già assegnato prima: lo si segna comunque come prova
    if (cart && interno() && cart.attributes && cart.attributes[AB.chiave] && cart.attributes._interno !== '1') {
      cart.attributes._interno = '1';
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _interno: '1' } }) }).catch(() => {});
    }
    if ((!AB.attivo && !forzato()) || !cart || cart.item_count === 0 || (cart.attributes && cart.attributes[AB.chiave])) return Promise.resolve();
    if (assegnando) return assegnando;
    assegnando = (async () => {
      const f = forzato();
      const r = f || (Math.random() < 0.5 ? 'A' : 'B');
      const attributes = { [AB.chiave]: r }; if (interno() || f) attributes._interno = '1';
      const res = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
      if (!res.ok) return;
      // si rilegge /cart.js: la risposta di update.js ha gli sconti in un'altra forma (mancava la riga «Sconto» dei 2 flaconi)
      cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      if (!cart.attributes || cart.attributes[AB.chiave] !== r) return;   // ramo non salvato: niente registrazione
      fetch(URL_DASH + '/ab', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, keepalive: true,
        body: JSON.stringify({ carrello: cart.token, ramo: r, interno: interno(), forzato: !!f }) }).catch(() => {});
      tr('ab_ramo', { r });
    })().catch(() => {}).finally(() => { assegnando = null; });
    return assegnando;
  }

  /* ---------- Meta Pixel: il pixel lo carica analytics-pixels dopo il consenso ---------- */
  function fb(event, data) { try { if (window.fbq) window.fbq('track', event, data); } catch (e) {} }
  function whenFb(fn) { let n = 0; const t = setInterval(() => { if (window.fbq) { clearInterval(t); fn(); } else if (++n > 60) clearInterval(t); }, 500); }

  /* ---------- Carrello ---------- */
  async function getCart() { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); await assegnaRamo(); render(); return cart; }
  async function add(qty) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: C.variant, quantity: qty }] }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Non è stato possibile aggiungere il prodotto.'); }
    fb('AddToCart', { content_ids: [String(C.productId)], content_type: 'product', content_name: C.title, value: bundleFor(qty) / 100, currency: 'EUR', num_items: qty });
    return getCart();
  }
  async function setQty(qty) {
    const line = cart && cart.items.find(i => i.variant_id === C.variant);
    if (!line) return add(qty);
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: Math.max(0, Math.min(10, qty)) }) });
    return getCart();
  }

  function render() {
    if (!cart) return;
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('on', cart.item_count > 0); });
    if (pc.passo && cart.item_count > 0) return pcRender();
    pc.passo = 0;
    const body = $('#drawer-body'), foot = $('#drawer-foot'); if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="empty"><p>Il carrello è vuoto.</p><p class="small muted">Un flacone = un trattamento completo, spedizione gratuita in Italia.</p><button class="btn btn-primary" data-add="1">Aggiungi Nanoplastia · ${fmt(C.price)}</button></div>`;
      foot.style.display = 'none'; return;
    }
    foot.style.display = '';
    const lines = cart.items.map(i => `
      <div class="line">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : C.image}" alt="">
        <div>
          <div class="n">${i.product_title}</div>
          <div class="v">${i.variant_title || ''}</div>
          <div class="qty"><button data-qty="-1" data-key="${i.key}" aria-label="Diminuisci">−</button><output>${i.quantity}</output><button data-qty="1" data-key="${i.key}" aria-label="Aumenta">+</button></div>
        </div>
        <div>
          <div class="p">${fmt(i.final_line_price)}</div>
          ${i.original_line_price > i.final_line_price ? `<div class="small" style="color:var(--ok);text-align:right">−${fmt(i.original_line_price - i.final_line_price)}</div>` : ''}
          <button class="rm" data-remove="${i.key}">Rimuovi</button>
        </div>
      </div>`).join('');
    const mine = cart.items.find(i => i.variant_id === C.variant);
    const upsell = mine && mine.quantity % 2 === 1
      ? `<div class="upsell"><img src="${C.image}" alt=""><div><b>Aggiungi il secondo a ${fmt(C.bundle2 - C.price)}</b><span>2 flaconi a ${fmt(C.bundle2)} invece di ${fmt(2 * C.price)}: per un'amica o per il prossimo trattamento.</span></div><button class="btn btn-dark" data-add="1">Aggiungi</button></div>` : '';
    body.innerHTML = `<div class="free-bar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg> Spedizione gratuita in Italia · consegna in ${C.days}</div>${lines}${upsell}`;
    const orderDisc = (cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
    foot.innerHTML = `
      <div class="totals">
        <div><span>Subtotale</span><span>${fmt(cart.items_subtotal_price)}</span></div>
        ${orderDisc > 0 ? `<div><span>Sconto</span><span class="disc">−${fmt(orderDisc)}</span></div>` : ''}
        <div><span>Spedizione in Italia</span><span class="free">Gratuita</span></div>
        <div class="tot"><span>Totale <span class="small muted" style="font-weight:400">IVA inclusa</span></span><span>${fmt(cart.total_price)}</span></div>
      </div>
      ${boxBenvenuto(cart, mine, orderDisc)}
      ${ramo() === 'B'
        ? `<button type="button" class="btn btn-primary btn-block btn-lg" data-precheckout>Vai al pagamento · ${fmt(cart.total_price)}</button>`
        : `<a class="btn btn-primary btn-block btn-lg" href="/checkout" data-checkout>Vai al pagamento · ${fmt(cart.total_price)}</a>`}`;
  }

  /* ---------- Pre-checkout (ramo B del test) ---------- */
  const pc = { passo: 0, visti: {}, dati: {}, via: 0 };
  const PROV = 'AG Agrigento|AL Alessandria|AN Ancona|AO Aosta|AR Arezzo|AP Ascoli Piceno|AT Asti|AV Avellino|BA Bari|BT Barletta-Andria-Trani|BL Belluno|BN Benevento|BG Bergamo|BI Biella|BO Bologna|BZ Bolzano|BS Brescia|BR Brindisi|CA Cagliari|CL Caltanissetta|CB Campobasso|CE Caserta|CT Catania|CZ Catanzaro|CH Chieti|CO Como|CS Cosenza|CR Cremona|KR Crotone|CN Cuneo|EN Enna|FM Fermo|FE Ferrara|FI Firenze|FG Foggia|FC Forlì-Cesena|FR Frosinone|GE Genova|GO Gorizia|GR Grosseto|IM Imperia|IS Isernia|AQ L\'Aquila|SP La Spezia|LT Latina|LE Lecce|LC Lecco|LI Livorno|LO Lodi|LU Lucca|MC Macerata|MN Mantova|MS Massa-Carrara|MT Matera|ME Messina|MI Milano|MO Modena|MB Monza e Brianza|NA Napoli|NO Novara|NU Nuoro|OR Oristano|PD Padova|PA Palermo|PR Parma|PV Pavia|PG Perugia|PU Pesaro e Urbino|PE Pescara|PC Piacenza|PI Pisa|PT Pistoia|PN Pordenone|PZ Potenza|PO Prato|RG Ragusa|RA Ravenna|RC Reggio Calabria|RE Reggio Emilia|RI Rieti|RN Rimini|RM Roma|RO Rovigo|SA Salerno|SS Sassari|SV Savona|SI Siena|SR Siracusa|SO Sondrio|SU Sud Sardegna|TA Taranto|TE Teramo|TR Terni|TO Torino|TP Trapani|TN Trento|TV Treviso|TS Trieste|UD Udine|VA Varese|VE Venezia|VB Verbano-Cusio-Ossola|VC Vercelli|VR Verona|VV Vibo Valentia|VI Vicenza|VT Viterbo'.split('|');
  // Sardegna: Shopify controlla che il CAP stia nella provincia e usa ancora le vecchie province (OT, OG, CI, VS).
  // Se il CAP cade lì si usa quella; «Sud Sardegna» senza corrispondenza diventa Cagliari (verificato dal vivo il 27/09).
  const SARD = [['OT', /^(0702|0703[08]|0705[12])/], ['OG', /^(0804[024-9]|09064)/], ['CI', /^0901[013-7]/], ['VS', /^(0902[0125679]|0903[015-9])/]];
  function provinciaPerShopify(prov, cap) { const z = SARD.find(([, re]) => re.test(cap)); return z ? z[0] : (prov === 'SU' ? 'CA' : prov); }
  function pcApri() { pc.passo = 1; pc.visti = {}; pc.via = 0; tr('pc_aperto'); pcRender(); }
  function pcIndietro() { tr('pc_indietro', { d: String(pc.passo) }); pc.passo = pc.passo === 2 ? 1 : 0; if (pc.passo) pcRender(); else render(); }
  function vaiAlCheckout(url, metodo) {
    if (pc.via) return; pc.via = 1;   // doppio tocco: un solo InitiateCheckout e un solo cambio pagina
    fb('InitiateCheckout', { value: cart.total_price / 100, currency: 'EUR', num_items: cart.item_count });
    tr('vai_pagamento', { r: metodo });
    location.href = url;
  }
  window.addEventListener('pageshow', () => { pc.via = 0; });   // ritorno col tasto indietro
  function pcMetodo(m) {
    tr('pc_metodo', { r: m });
    if (m === 'online') return vaiAlCheckout('/checkout', 'online');   // PayPal, Apple Pay e Google Pay sono in cima al checkout
    pc.passo = 2; pcRender();
  }
  function pcRender() {
    const body = $('#drawer-body'), foot = $('#drawer-foot'); if (!body || !cart) return;
    foot.style.display = 'none';
    const tot = fmt(cart.total_price);
    if (pc.passo === 1) {
      body.innerHTML = `<div class="pc">
        <button type="button" class="pc-back" data-pc-indietro>← Torna al carrello</button>
        <h3>Come vuoi pagare?</h3>
        <p class="pc-sub">Totale ${tot} · spedizione gratuita</p>
        <button type="button" class="pc-opt" data-pc-metodo="contanti"><b>💶 In contanti alla consegna</b><span>Paghi al corriere quando arriva. Nessun costo in più.</span></button>
        <button type="button" class="pc-opt" data-pc-metodo="online"><b>Online</b><span>Carta, PayPal, Apple Pay, Google Pay o Klarna. Pagamento protetto da Shopify.</span></button>
      </div>`;
      body.scrollTop = 0; return;
    }
    const val = (n) => String(pc.dati[n] || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const campo = (n, l, t, extra) => `<label>${l}<input name="${n}" type="${t}" value="${val(n)}" ${extra || ''}></label>`;
    body.innerHTML = `<div class="pc">
      <button type="button" class="pc-back" data-pc-indietro>← Cambia metodo di pagamento</button>
      <h3>Dove lo spediamo?</h3>
      <p class="pc-sub">Paghi ${tot} in contanti al corriere, nessun costo in più.</p>
      <form data-pc-form novalidate>
        <div class="pc-2">${campo('nome', 'Nome', 'text', 'autocomplete="given-name"')}${campo('cognome', 'Cognome', 'text', 'autocomplete="family-name"')}</div>
        ${campo('telefono', 'Telefono (per il corriere e la conferma su WhatsApp)', 'tel', 'autocomplete="tel-national" inputmode="tel" placeholder="333 123 4567"')}
        ${campo('email', 'Email (per la conferma d\'ordine)', 'email', 'autocomplete="email" inputmode="email"')}
        ${campo('indirizzo', 'Via e numero civico', 'text', 'autocomplete="address-line1"')}
        <div class="pc-2">${campo('cap', 'CAP', 'text', 'autocomplete="postal-code" inputmode="numeric" maxlength="5"')}${campo('citta', 'Città', 'text', 'autocomplete="address-level2"')}</div>
        <label>Provincia<select name="provincia" autocomplete="address-level1"><option value="">Scegli…</option>${PROV.map(p => `<option value="${p.slice(0, 2)}">${p.slice(3)}</option>`).join('')}</select></label>
        <p class="pc-err" hidden></p>
        <p class="pc-hint">Nella pagina dopo trovi i tuoi dati già scritti. Scorri fino a <b>Pagamento</b> e tocca <b>«💶 Paga in contanti alla consegna»</b>: la carta non serve.</p>
        <button type="submit" class="btn btn-primary btn-block btn-lg">Continua · ${tot}</button>
      </form>
    </div>`;
    const sel = $('[data-pc-form] [name=provincia]', body); if (sel && pc.dati.provincia) sel.value = pc.dati.provincia;
    body.scrollTop = 0;
  }
  // quello che scrive resta in memoria finché la pagina è aperta (mai salvato nel browser);
  // appena corregge un campo via il bordo rosso, e via il messaggio quando non restano errori
  document.addEventListener('input', (e) => {
    const f = e.target.closest && e.target.closest('[data-pc-form]'); if (!f) return;
    if (e.target.name) pc.dati[e.target.name] = e.target.value;
    if (e.target.name === 'indirizzo') delete f.dataset.civico;
    e.target.removeAttribute('aria-invalid');
    if (!f.querySelector('[aria-invalid]')) { const er = f.querySelector('.pc-err'); if (er) er.hidden = true; }
  });
  document.addEventListener('change', (e) => { const s = e.target.closest && e.target.closest('[data-pc-form] select'); if (s) { pc.dati[s.name] = s.value; s.removeAttribute('aria-invalid'); } });
  // quale campo toccano (mai il contenuto): per vedere dove si ferma chi abbandona
  document.addEventListener('focusin', (e) => {
    const i = e.target.closest && e.target.closest('[data-pc-form] input, [data-pc-form] select'); if (!i || pc.visti[i.name]) return;
    pc.visti[i.name] = 1; tr('pc_campo', { d: i.name });
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('[data-pc-form]'); if (!f) return;
    e.preventDefault();
    const v = (n) => (f.elements[n].value || '').trim();
    const tel = v('telefono').replace(/[\s.\-\/()]/g, '').replace(/^(\+39|0039)/, '');
    const ind = v('indirizzo');
    const errori = [];
    if (!v('nome')) errori.push(['nome', 'Scrivi il nome']);
    if (!v('cognome')) errori.push(['cognome', 'Scrivi il cognome']);
    if (!/^(3\d{8,9}|0\d{5,10})$/.test(tel)) errori.push(['telefono', 'Controlla il numero di telefono']);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v('email'))) errori.push(['email', "Controlla l'email"]);
    if (ind.length < 5) errori.push(['indirizzo', 'Scrivi la via e il numero civico']);
    // senza numero civico si avvisa una volta sola: contrade e «snc» sono indirizzi validi
    else if (!/\d|\bs\.?\s?n\.?\s?c?\.?(\s|$)|\bkm\b/i.test(ind) && !f.dataset.civico) { f.dataset.civico = '1'; errori.push(['indirizzo', "Manca il numero civico? Se non c'è scrivi «snc» oppure premi di nuovo Continua"]); }
    if (!/^\d{5}$/.test(v('cap'))) errori.push(['cap', 'Il CAP ha 5 cifre']);
    if (!v('citta')) errori.push(['citta', 'Scrivi la città']);
    if (!v('provincia')) errori.push(['provincia', 'Scegli la provincia']);
    $$('input, select', f).forEach(el => el.removeAttribute('aria-invalid'));
    const err = $('.pc-err', f);
    if (errori.length) {
      errori.forEach(([n]) => f.elements[n].setAttribute('aria-invalid', 'true'));
      err.textContent = errori[0][1]; err.hidden = false; f.elements[errori[0][0]].focus();
      tr('pc_errore', { d: errori.map(x => x[0]).join(',') }); return;
    }
    err.hidden = true;
    const bottone = f.querySelector('[type=submit]'); if (bottone) { bottone.disabled = true; bottone.textContent = 'Un attimo…'; }
    const p = new URLSearchParams();
    p.set('checkout[email]', v('email'));
    p.set('checkout[shipping_address][first_name]', v('nome'));
    p.set('checkout[shipping_address][last_name]', v('cognome'));
    p.set('checkout[shipping_address][address1]', ind);
    p.set('checkout[shipping_address][city]', v('citta'));
    p.set('checkout[shipping_address][zip]', v('cap'));
    p.set('checkout[shipping_address][province]', provinciaPerShopify(v('provincia'), v('cap')));
    p.set('checkout[shipping_address][country]', 'IT');
    p.set('checkout[shipping_address][phone]', '+39' + tel);
    const codici = (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code);
    if (codici.length) p.set('discount', codici.join(','));
    Object.entries(cart.attributes || {}).forEach(([k, val]) => { if (val != null && val !== '') p.set(`attributes[${k}]`, String(val)); });
    p.set('attributes[_pc_metodo]', 'contanti');
    const righe = cart.items.map(i => `${i.variant_id}:${i.quantity}`).join(',');
    // il link al carrello riusa lo stesso carrello e apre il checkout già compilato; Shopify toglie i dati dall'indirizzo
    vaiAlCheckout(`/cart/${righe}?${p.toString()}`, 'contanti');
  });
  // 24/09/2026 — Il 10% di benvenuto dentro il carrello. Prima esisteva solo nel popup, che dal
  // 23/09 non si apre piu' a chi sta comprando: qui lo trova chi e' gia' deciso, senza coprire nulla.
  // Solo sul flacone singolo (sui 2 flaconi vale il prezzo offerta), solo se non c'e' gia' uno sconto
  // e se questa persona non si e' gia' iscritta. Stesso codice e stessa iscrizione del popup, piu'
  // il tag benvenuto-carrello per contare quante vendite arrivano da qui.
  const BENV_CODE = 'BENVENUTA10', BENV_KEY = 'nei_pop_v2';
  function giaIscritta() { try { const s = JSON.parse(localStorage.getItem(BENV_KEY) || 'null'); return !!(s && s.iscritta); } catch (e) { return false; } }
  function boxBenvenuto(cart, mine, orderDisc) {
    const lineDisc = cart.items.some(i => i.original_line_price > i.final_line_price);
    if (!mine || cart.item_count !== 1 || orderDisc > 0 || lineDisc || giaIscritta()) return '';
    const scontato = Math.round(C.price * 0.9);
    return `<form class="benv" data-benvenuto novalidate>
        <div class="benv-t"><b>Primo ordine?</b> Lascia la tua email e paghi <b>${fmt(scontato)}</b> invece di ${fmt(C.price)}.</div>
        <div class="benv-r"><input type="email" name="email" placeholder="La tua email" autocomplete="email" inputmode="email" required>
        <button type="submit" class="btn btn-dark">Applica</button></div>
        <div class="benv-e" hidden></div>
        <div class="benv-c">Ricevi anche le nostre offerte via email, puoi cancellarti quando vuoi.</div>
      </form>`;
  }
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('[data-benvenuto]'); if (!f) return;
    e.preventDefault();
    const inp = f.querySelector('input[name="email"]'), email = (inp.value || '').trim(), err = f.querySelector('.benv-e');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      err.textContent = email ? "Controlla l'indirizzo: manca qualcosa" : 'Scrivi la tua email per lo sconto';
      err.hidden = false; inp.focus(); return;
    }
    err.hidden = true;
    fetch('https://visiione.com/neimien/dashboard/iscrivi', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ email, da: 'carrello', pagina: location.pathname })
    }).catch(() => {});
    try { localStorage.setItem(BENV_KEY, JSON.stringify({ iscritta: true, email, quando: Date.now(), da: 'carrello' })); } catch (e2) {}
    f.querySelector('button[type=submit]').textContent = 'Un attimo…';
    // 27/09/2026: lo sconto si applica restando nel carrello (/cart/update.js con discount, verificato); prima si
    // saltava dritti al checkout e molti lo aprivano «per vedere». Se non riesce, si torna al vecchio link /discount/.
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: BENV_CODE }) })
      .then(r => { if (!r.ok) throw new Error('sconto'); return r.json(); })
      .then(d => {
        const vale = (d.discount_codes || []).some(x => x.code === BENV_CODE && x.applicable);
        return getCart().then(() => { if (vale) tr('sconto_carrello_ok'); else alertInDrawer('Lo sconto non vale su questo carrello.'); });
      })
      .catch(() => { location.href = '/discount/' + BENV_CODE + '?redirect=' + encodeURIComponent(location.pathname + location.search); });
  });
  (function stileBenvenuto() {
    const st = document.createElement('style');
    st.textContent = '.benv{margin:10px 0 12px;padding:12px;border:1px dashed rgba(192,97,58,.55);border-radius:12px;background:rgba(192,97,58,.06)}'
      + '.benv-t{font-size:13.5px;line-height:1.4;margin-bottom:8px}'
      + '.benv-r{display:flex;gap:8px}.benv-r input{flex:1;min-width:0;padding:10px 12px;border:1px solid rgba(0,0,0,.15);border-radius:10px;font:inherit;font-size:16px}'
      + '.pay-rassicura{font-size:12.5px;line-height:1.45;margin:8px 0 2px;color:#4A4540}'
      + '.cod-nota{font-size:12.5px;line-height:1.4;margin:10px 0 2px;padding:9px 11px;border-radius:10px;background:#F1EBE0;color:#4A4540}'
      + '.benv-c{font-size:11px;opacity:.65;margin-top:6px}.benv-r .btn{padding:10px 14px;white-space:nowrap}.benv-e{color:#C0392B;font-size:12.5px;margin-top:6px}'
      + '.pc{padding:2px 0 16px}.pc h3{font-size:21px;margin:6px 0 4px}.pc-sub{font-size:14px;color:#6b635b;margin:0 0 14px}'
      + '.pc-back{background:none;border:0;padding:6px 0;font:inherit;font-size:14px;color:#4A4540;text-decoration:underline;cursor:pointer}'
      + '.pc-opt{display:block;width:100%;text-align:left;margin:0 0 10px;padding:15px 16px;border:1.5px solid rgba(0,0,0,.14);border-radius:14px;background:#fff;font:inherit;color:inherit;cursor:pointer}'
      + '.pc-opt b{display:block;font-size:16px;margin-bottom:3px}.pc-opt span{display:block;font-size:13.5px;color:#6b635b;line-height:1.4}.pc-opt:active,.pc-opt:hover{border-color:#C0613A}'
      + '.pc form label{display:block;font-size:13px;font-weight:600;margin:0 0 10px}.pc-2{display:grid;grid-template-columns:1fr 1fr;gap:8px}'
      + '.pc form input,.pc form select{display:block;width:100%;box-sizing:border-box;margin-top:4px;padding:11px 12px;border:1px solid rgba(0,0,0,.18);border-radius:10px;font:inherit;font-size:16px;background:#fff;color:inherit}'
      + '.pc form [aria-invalid=true]{border-color:#C0392B}.pc-err{color:#C0392B;font-size:13.5px;margin:4px 0 10px}.pc-hint{font-size:12.5px;color:#6b635b;line-height:1.45;margin:10px 0 0}';
    document.head.appendChild(st);
  })();

  function openDrawer() { document.body.classList.add('drawer-open'); if (!cart) getCart(); }
  function closeDrawer() {
    if (pc.passo) { tr('pc_chiuso', { d: String(pc.passo) }); pc.passo = 0; render(); }
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      e.preventDefault(); const q = parseInt(addBtn.dataset.add, 10) || 1;
      addBtn.classList.add('loading');
      try { openDrawer(); await add(q); } catch (err) { alertInDrawer(err.message); } finally { addBtn.classList.remove('loading'); }
      return;
    }
    const buy = e.target.closest('[data-buy-now]');
    if (buy) {
      // 27/09/2026: «Acquista subito» passa dal carrello normale (prima il link creava un carrello nuovo e perdeva
      // sconto, ramo del test e cookie di Meta); poi checkout (ramo A) o pre-checkout (ramo B).
      e.preventDefault(); const q = parseInt(buy.dataset.buyNow, 10) || 1;
      buy.classList.add('loading');
      try { await setQty(q); } catch (err) { openDrawer(); alertInDrawer(err.message); return; } finally { buy.classList.remove('loading'); }
      if (ramo() === 'B') { openDrawer(); pcApri(); } else vaiAlCheckout('/checkout', 'diretto');
      return;
    }
    if (e.target.closest('[data-precheckout]')) { e.preventDefault(); pcApri(); return; }
    const pm = e.target.closest('[data-pc-metodo]'); if (pm) { e.preventDefault(); pcMetodo(pm.dataset.pcMetodo); return; }
    if (e.target.closest('[data-pc-indietro]')) { e.preventDefault(); pcIndietro(); return; }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
    const qb = e.target.closest('[data-qty]');
    if (qb) { const line = cart.items.find(i => i.key === qb.dataset.key); if (line) { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity + parseInt(qb.dataset.qty, 10) }) }); getCart(); } return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 }) }); getCart(); return; }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  function alertInDrawer(msg) { const b = $('#drawer-body'); if (b) b.insertAdjacentHTML('afterbegin', `<div class="free-bar" style="color:var(--err)">${msg}</div>`); }

  /* ---------- Pagina ---------- */
  function page() {
    // Formato 1 / 2 flaconi
    const pills = $$('.pill'); let sel = 1;
    function applySel() {
      const price = sel === 2 ? C.bundle2 : C.price;
      pills.forEach(p => { const on = p.dataset.qty == sel; p.classList.toggle('on', on); p.setAttribute('aria-checked', on); });
      $$('[data-sel-price]').forEach(el => el.textContent = fmt(price));
      $$('[data-sel-qty]').forEach(el => el.dataset.add = sel);
      $$('[data-sel-buy]').forEach(el => el.dataset.buyNow = sel);
      $$('[data-sel-per]').forEach(el => el.textContent = sel > 1 ? `${fmt(price / sel)} a flacone` : `${fmt(price)} a trattamento`);
    }
    pills.forEach(p => p.addEventListener('click', () => { sel = parseInt(p.dataset.qty, 10); applySel(); }));
    if (pills.length) applySel();

    // Galleria
    const main = $('.gallery-main img');
    $$('.gallery-thumbs button').forEach(b => b.addEventListener('click', () => {
      $$('.gallery-thumbs button').forEach(x => x.classList.remove('on')); b.classList.add('on');
      main.style.opacity = 0; setTimeout(() => { main.src = b.dataset.src; main.alt = b.querySelector('img').alt; main.style.opacity = 1; }, 150);
    }));

    // Consegna stimata
    const eta = $('[data-eta]');
    if (eta) {
      const now = new Date(); const today = now.getHours() < C.cutoff && now.getDay() >= 1 && now.getDay() <= 5;
      const d = new Date(now); let n = today ? 1 : 2;
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() >= 1 && d.getDay() <= 5) n--; }
      const d2 = new Date(d); do { d2.setDate(d2.getDate() + 1); } while (d2.getDay() === 0 || d2.getDay() === 6);
      const f = (x) => x.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
      eta.innerHTML = today ? `Ordina <b>entro le ${C.cutoff}:00</b> e parte oggi · consegna stimata <b>${f(d)} – ${f(d2)}</b>` : `Consegna stimata <b>${f(d)} – ${f(d2)}</b>`;
    }

    // Prima/dopo
    $$('.ba').forEach(ba => { const r = ba.querySelector('input[type=range]'); const u = () => ba.style.setProperty('--x', r.value + '%'); r.addEventListener('input', u); u(); });

    // Video
    $$('.vid').forEach(v => {
      const video = v.querySelector('video'), btn = v.querySelector('.play');
      btn.addEventListener('click', () => { $$('.vid video').forEach(o => { if (o !== video) { o.pause(); o.parentElement.classList.remove('playing'); } }); video.play(); v.classList.add('playing'); });
      video.addEventListener('click', () => { video.pause(); v.classList.remove('playing'); });
      video.addEventListener('ended', () => v.classList.remove('playing'));
    });

    // Barra acquisto mobile
    const buyCta = $('.buy-cta'), bar = $('#pdpSticky');
    if (buyCta && bar && 'IntersectionObserver' in window && window.matchMedia('(max-width: 960px)').matches) {
      document.body.classList.add('has-sticky');
      new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.hidden = !show; bar.classList.toggle('show', show); }).observe(buyCta);
    }

    // ViewContent anche sulla home (sulla scheda prodotto lo manda già analytics-pixels)
    if (!document.body.classList.contains('template-product')) whenFb(() => fb('ViewContent', { content_ids: [String(C.productId)], content_type: 'product', content_name: C.title, value: C.price / 100, currency: 'EUR' }));

    quiz();
  }

  /* ---------- Quiz ---------- */
  function quiz() {
    const q = $('#quiz'); if (!q) return;
    const qs = $$('.quiz-q', q), steps = $$('.quiz-steps span', q);
    const res = $('.quiz-res', q), yes = $('.quiz-res-yes', q), no = $('.quiz-res-no', q), back = $('[data-quiz-back]', q);
    let i = 0; const a = [];
    function show(n) { i = n; qs.forEach((el, k) => el.hidden = k !== n); res.hidden = true; yes.hidden = no.hidden = true; steps.forEach((s, k) => s.classList.toggle('on', k <= n)); back.hidden = n === 0; }
    function result() {
      qs.forEach(el => el.hidden = true); res.hidden = false; back.hidden = true; steps.forEach(s => s.classList.add('on'));
      const [tipo, stato, lung] = a;
      if (stato === 'decolorati' || stato === 'danneggiati') {
        no.hidden = false;
        $('[data-note-no]', q).textContent = stato === 'decolorati'
          ? 'Sui capelli decolorati o schiariti, o già passati da trattamenti chimici intensivi, la fibra è troppo fragile: il trattamento potrebbe stressarla invece di disciplinarla. Lo scriviamo anche nelle avvertenze.'
          : 'Se i capelli si spezzano, prima di qualsiasi trattamento disciplinante serve ricostruire la fibra. Un buon parrucchiere di fiducia ti può dire quando è il momento giusto.';
        fb('Lead', { content_name: 'quiz_no', content_category: `${tipo}-${stato}-${lung}` }); return;
      }
      yes.hidden = false; const note = [];
      if (tipo === 'ricci') note.push('Sui ricci il risultato è un liscio più morbido e molto più gestibile; sui ricci molto stretti il liscio non è assoluto, ma il crespo e il volume si disciplinano.');
      if (tipo === 'crespi') note.push('Il crespo è esattamente il caso in cui il trattamento rende di più: la fibra viene sigillata e resta compatta anche con l\'umidità.');
      if (stato === 'colorati') note.push('Sui capelli colorati puoi usarlo tranquillamente: il colore resta e la lucentezza aumenta.');
      if (lung === 'moltolunghi') note.push('Con capelli molto lunghi e folti usa tutto il flacone senza risparmiarlo: se in due volete farlo, o vuoi già il prossimo trattamento, il formato da 2 flaconi conviene.');
      $('[data-note]', q).textContent = note.join(' ');
      fb('Lead', { content_name: 'quiz_yes', content_category: `${tipo}-${stato}-${lung}` });
    }
    q.addEventListener('click', (e) => {
      const opt = e.target.closest('.quiz-opts button');
      if (opt) { a[i] = opt.dataset.v; if (i < qs.length - 1) show(i + 1); else result(); return; }
      if (e.target.closest('[data-quiz-back]')) { show(Math.max(0, i - 1)); return; }
      if (e.target.closest('[data-quiz-reset]')) { a.length = 0; show(0); q.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* ---------- Reveal ---------- */
  function reveal() {
    if (!('IntersectionObserver' in window)) { $$('.reveal').forEach(el => el.classList.add('in')); return; }
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: .12 });
    $$('.reveal').forEach(el => io.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => { getCart(); reveal(); page(); });
})();
